import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {getProfile} from '/redux/action/coach.action';
import {
  accountEmailById,
  hasProfileById,
  phoneNumberById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import AccountSettings from './AccountSettings';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    hasProfile: withCurrentUserCoachId(hasProfileById),
    email: withCurrentUserCoachId(accountEmailById),
    phone: withCurrentUserCoachId(phoneNumberById),
  }),
  dispatch => ({
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getProfile: ({coachId}: any) => dispatch(getProfile({userId})),
  }),
)(AccountSettings);
